import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router);

const router = new Router({
    mode: 'history',
    routes: [
        /** Home, front page */
        {
            path: '/',
            alias: '/etusivu',
            name: 'fi.Home',
            component: () => import(/* webpackPrefetch: true */'@/views/Home'),
            props: true,
            meta: {
                loginReturnUrl: '/',
                scroll: 'top',
                navbarClassName: 'dark transparent absolute'
            }
        },
        {
            path: '/',
            alias: '/home',
            name: 'en.Home',
            component: () => import(/* webpackPrefetch: true */'@/views/Home'),
            props: true,
            meta: {
                loginReturnUrl: '/',
                scroll: 'top',
                navbarClassName: 'dark transparent absolute'
            }
        },
        {
            path: '/',
            alias: '/hem',
            name: 'sv.Home',
            component: () => import(/* webpackPrefetch: true */'@/views/Home'),
            props: true,
            meta: {
                loginReturnUrl: '/',
                scroll: 'top',
                navbarClassName: 'dark transparent absolute'
            }
        },


        /** User profile */
        {
            path: '/userprofile/:section?',
            name: 'UserProfile',
            component: () => import('@/views/UserProfile'),
            props: true,
            meta: {
                scroll: 'top'
            }
        },

        /** Global search */
        {
            path: '/haku',
            name: 'fi.Search',
            component: () => import('@/views/IndexSearch'),
            meta: {
                scroll: 'top'
            }
        },
        {
            path: '/search',
            name: 'en.Search',
            component: () => import('@/views/IndexSearch'),
            meta: {
                scroll: 'top'
            }
        },
        {
            path: '/s%C3%B6k',
            name: 'sv.Search',
            component: () => import('@/views/IndexSearch'),
            meta: {
                scroll: 'top'
            }
        },

        /** Events aka "exhibitions" */
        {
            path: '/nayttelyt/luo/:parentId?/:contentgroupTags?',
            alias: '/n%C3%A4yttelyt/luo/:parentId?/:contentgroupTags?',
            name: 'fi.EventCreate',
            component: () => import('@/views/EventPage'),
            props: true,
            meta: {
                scroll: 'top'
            }
        },
        {
            path: '/exhibitions/create/:parentId?/:contentgroupTags?',
            name: 'en.EventCreate',
            component: () => import('@/views/EventPage'),
            props: true,
            meta: {
                scroll: 'top'
            }
        },
        {
            path: '/utst%C3%A4llningar/skapa/:parentId?/:contentgroupTags?',
            name: 'sv.EventCreate',
            component: () => import('@/views/EventPage'),
            props: true,
            meta: {
                scroll: 'top'
            }
        },
        {
            path: '/nayttelyt/haku',
            alias: '/n%C3%A4yttelyt/haku',
            name: 'fi.EventsSearch',
            component: () => import('@/views/EventsSearch'),
            props: true,
            meta: {
                scroll: 'top'
            }
        },
        {
            path: '/exhibitions/search',
            name: 'en.EventsSearch',
            component: () => import('@/views/EventsSearch'),
            props: true,
            meta: {
                scroll: 'top'
            }
        },
        {
            path: '/utst%C3%A4llningar/s%C3%B6k',
            name: 'sv.EventsSearch',
            component: () => import('@/views/EventsSearch'),
            props: true,
            meta: {
                scroll: 'top'
            }
        },
        {
            path: '/nayttelyt/:id/:urlName?/:section?',
            alias: '/n%C3%A4yttelyt/:id/:urlName?/:section?',
            name: 'fi.EventPage',
            component: () => import(/* webpackPrefetch: true */'@/views/EventPage'),
            props: true,
            meta: {
                scroll: 'top'
            }
        },
        {
            path: '/exhibitions/:id/:urlName?/:section?',
            name: 'en.EventPage',
            component: () => import(/* webpackPrefetch: true */'@/views/EventPage'),
            props: true,
            meta: {
                scroll: 'top'
            }
        },
        {
            path: '/utst%C3%A4llningar/:id/:urlName?/:section?',
            name: 'sv.EventPage',
            component: () => import(/* webpackPrefetch: true */'@/views/EventPage'),
            props: true,
            meta: {
                scroll: 'top'
            }
        },
        {
            path: '/nayttelyt',
            alias: '/n%C3%A4yttelyt',
            name: 'fi.Events',
            component: () => import('@/views/EventsIndex')
        },
        {
            path: '/exhibitions',
            name: 'en.Events',
            component: () => import('@/views/EventsIndex')
        },
        {
            path: '/utst%C3%A4llningar',
            name: 'sv.Events',
            component: () => import('@/views/EventsIndex')
        },

        /** Collections */
        {
            path: '/kokoelmat/haku',
            name: 'fi.CollectionsSearch',
            component: () => import('@/views/CollectionsSearch'),
            meta: {
                scroll: 'top'
            }
        },
        {
            path: '/collections/search',
            name: 'en.CollectionsSearch',
            component: () => import('@/views/CollectionsSearch'),
            meta: {
                scroll: 'top'
            }
        },
        {
            path: '/kollektioner/s%C3%B6k',
            name: 'sv.CollectionsSearch',
            component: () => import('@/views/CollectionsSearch'),
            meta: {
                scroll: 'top'
            }
        },
        {
            path: '/kokoelmat/:id/:urlName?/:section?',
            name: 'fi.CollectionPage',
            component: () => import('@/views/CollectionPage'),
            props: true,
            meta: {
                scroll: 'top'
            }
        },
        {
            path: '/collections/:id/:urlName?/:section?',
            name: 'en.CollectionPage',
            component: () => import('@/views/CollectionPage'),
            props: true,
            meta: {
                scroll: 'top'
            }
        },
        {
            path: '/kollektioner/:id/:urlName?/:section?',
            name: 'sv.CollectionPage',
            component: () => import('@/views/CollectionPage'),
            props: true,
            meta: {
                scroll: 'top'
            }
        },
        {
            path: '/kokoelmat',
            name: 'fi.Collections',
            component: () => import('@/views/CollectionsIndex')
        },
        {
            path: '/collections',
            name: 'en.Collections',
            component: () => import('@/views/CollectionsIndex')
        },
        {
            path: '/kollektioner',
            name: 'sv.Collections',
            component: () => import('@/views/CollectionsIndex')
        },

        /** Galleries
        {
            path: '/galleriat',
            name: 'fi.Galleries',
            component: () => import('@/views/GalleriesIndex')
        },
        {
            path: '/galleries',
            name: 'en.Galleries',
            component: () => import('@/views/GalleriesIndex')
        },
        {
            path: '/gallerier',
            name: 'sv.Galleries',
            component: () => import('@/views/GalleriesIndex')
        },
        {
            path: '/galleriat/:id/:urlName?/:section?',
            name: 'fi.GalleryPage',
            component: () => import('@/views/GalleryPage'),
            props: true,
            meta: {
                scroll: 'top'
            }
        },
        {
            path: '/galleries/:id/:urlName?/:section?',
            name: 'en.GalleryPage',
            component: () => import('@/views/GalleryPage'),
            props: true,
            meta: {
                scroll: 'top'
            }
        },
        {
            path: '/gallerier/:id/:urlName?/:section?',
            name: 'sv.GalleryPage',
            component: () => import('@/views/GalleryPage'),
            props: true,
            meta: {
                scroll: 'top'
            }
        }, */

        /** Actors aka "artists" */
        {
            path: '/taiteilijat/haku',
            name: 'fi.ActorsSearch',
            component: () => import('@/views/ActorsSearch'),
            meta: {
                scroll: 'top'
            }
        },
        {
            path: '/artists/search',
            name: 'en.ActorsSearch',
            component: () => import('@/views/ActorsSearch'),
            meta: {
                scroll: 'top'
            }
        },
        {
            path: '/artister/s%C3%B6k',
            name: 'sv.ActorsSearch',
            component: () => import('@/views/ActorsSearch'),
            meta: {
                scroll: 'top'
            }
        },
        {
            path: '/taiteilijat/:id/:urlName?/:section?',
            name: 'fi.ActorPage',
            component: () => import('@/views/ActorPage'),
            props: true,
            meta: {
                scroll: 'top'
            }
        },
        {
            path: '/artists/:id/:urlName?/:section?',
            name: 'en.ActorPage',
            component: () => import('@/views/ActorPage'),
            props: true,
            meta: {
                scroll: 'top'
            }
        },
        {
            path: '/artister/:id/:urlName?/:section?',
            name: 'sv.ActorPage',
            component: () => import('@/views/ActorPage'),
            props: true,
            meta: {
                scroll: 'top'
            }
        },
        {
            path: '/taiteilijat',
            name: 'fi.Actors',
            component: () => import(/* webpackPrefetch: true */'@/views/ActorsIndex')
        },
        {
            path: '/artists',
            name: 'en.Actors',
            component: () => import(/* webpackPrefetch: true */'@/views/ActorsIndex')
        },
        {
            path: '/artister',
            name: 'sv.Actors',
            component: () => import(/* webpackPrefetch: true */'@/views/ActorsIndex')
        },

        /** Artworks */
        {
            path: '/teokset/haku',
            name: 'fi.ArtworksSearch',
            component: () => import(/* webpackPrefetch: true */'@/views/ArtworksSearch'),
            meta: {
                scroll: 'top'
            }
        },
        {
            path: '/artworks/search',
            name: 'en.ArtworksSearch',
            component: () => import(/* webpackPrefetch: true */'@/views/ArtworksSearch'),
            meta: {
                scroll: 'top'
            }
        },
        {
            path: '/konstverk/s%C3%B6k',
            name: 'sv.ArtworksSearch',
            component: () => import(/* webpackPrefetch: true */'@/views/ArtworksSearch'),
            meta: {
                scroll: 'top'
            }
        },
        {
            path: '/teokset/:id/:urlName?',
            name: 'fi.ArtworkPage',
            component: () => import('@/views/ArtworkPage'),
            props: true,
            meta: {
                scroll: 'top'
            }
        },
        {
            path: '/artworks/:id/:urlName?',
            name: 'en.ArtworkPage',
            component: () => import('@/views/ArtworkPage'),
            props: true,
            meta: {
                scroll: 'top'
            }
        },
        {
            path: '/konstverk/:id/:urlName?',
            name: 'sv.ArtworkPage',
            component: () => import('@/views/ArtworkPage'),
            props: true,
            meta: {
                scroll: 'top'
            }
        },
        {
            path: '/teokset',
            name: 'fi.Artworks',
            component: () => import('@/views/ArtworksIndex')
        },
        {
            path: '/artworks',
            name: 'en.Artworks',
            component: () => import('@/views/ArtworksIndex')
        },
        {
            path: '/konstverk',
            name: 'sv.Artworks',
            component: () => import('@/views/ArtworksIndex')
        },

        /** Organizations */
        {
            path: '/yhteisot',
            alias: '/yhteis%C3%B6t',
            name: 'fi.Organizations',
            component: () => import('@/views/OrganizationsIndex')
        },
        {
            path: '/organizations',
            name: 'en.Organizations',
            component: () => import('@/views/OrganizationsIndex')
        },
        {
            path: '/organisationer',
            name: 'sv.Organizations',
            component: () => import('@/views/OrganizationsIndex')
        },
        {
            path: '/yhteisot/haku',
            alias: '/yhteis%C3%B6t/haku',
            name: 'fi.OrganizationsSearch',
            component: () => import('@/views/OrganizationsSearch'),
            meta: {
                scroll: 'top'
            }
        },
        {
            path: '/organizations/search',
            name: 'en.OrganizationsSearch',
            component: () => import('@/views/OrganizationsSearch'),
            meta: {
                scroll: 'top'
            }
        },
        {
            path: '/organisationer/s%C3%B6k',
            name: 'sv.OrganizationsSearch',
            component: () => import('@/views/OrganizationsSearch'),
            meta: {
                scroll: 'top'
            }
        },
        {
            path: '/yhteisot/:id/:urlName?/:section?/:hunk?',
            alias: '/yhteis%C3%B6t/:id/:urlName?/:section?/:hunk?',
            name: 'fi.OrganizationPage',
            component: () => import('@/views/OrganizationPage'),
            props: true,
            meta: {
                scroll: 'top'
            }
        },
        {
            path: '/organizations/:id/:urlName?/:section?/:hunk?',
            name: 'en.OrganizationPage',
            component: () => import('@/views/OrganizationPage'),
            props: true,
            meta: {
                scroll: 'top'
            }
        },
        {
            path: '/organisationer/:id/:urlName?/:section?/:hunk?',
            name: 'sv.OrganizationPage',
            component: () => import('@/views/OrganizationPage'),
            props: true,
            meta: {
                scroll: 'top'
            }
        },

        /** Articles */
        {
            path: '/artikkelit/luo/:parentId?/:contentgroupTags?',
            name: 'fi.ArticleCreate',
            component: () => import('@/views/ArticlePage'),
            props: true,
            meta: {
                scroll: 'top'
            }
        },
        {
            path: '/articles/create/:parentId?/:contentgroupTags?',
            name: 'en.ArticleCreate',
            component: () => import('@/views/ArticlePage'),
            props: true,
            meta: {
                scroll: 'top'
            }
        },
        {
            path: '/skrifter/skapa/:parentId?/:contentgroupTags?',
            alias: '/artiklar/skapa/:parentId?/:contentgroupTags?',
            name: 'sv.ArticleCreate',
            component: () => import('@/views/ArticlePage'),
            props: true,
            meta: {
                scroll: 'top'
            }
        },
        {
            path: '/artikkelit/:id/:urlName?/:parentId?',
            name: 'fi.ArticlePage',
            component: () => import('@/views/ArticlePage'),
            props: true,
            meta: {
                scroll: 'top'
            }
        },
        {
            path: '/articles/:id/:urlName?/:parentId?',
            name: 'en.ArticlePage',
            component: () => import('@/views/ArticlePage'),
            props: true,
            meta: {
                scroll: 'top'
            }
        },
        {
            path: '/skrifter/:id/:urlName?/:parentId?',
            alias: '/artiklar/:id/:urlName?/:parentId?',
            name: 'sv.ArticlePage',
            component: () => import('@/views/ArticlePage'),
            props: true,
            meta: {
                scroll: 'top'
            }
        },
        {
            path: '/artikkelit',
            name: 'fi.Articles',
            component: () => import('@/views/ArticlesIndex')
        },
        {
            path: '/articles',
            name: 'en.Articles',
            component: () => import('@/views/ArticlesIndex')
        },
        {
            path: '/skrifter',
            alias: '/artiklar',
            name: 'sv.Articles',
            component: () => import('@/views/ArticlesIndex')
        },

        /** Videos */
        {
            path: '/videot/haku',
            name: 'fi.VideosSearch',
            component: () => import('@/views/VideosSearch'),
            meta: {
                scroll: 'top'
            }
        },
        {
            path: '/videos/search',
            name: 'en.VideosSearch',
            component: () => import('@/views/VideosSearch'),
            meta: {
                scroll: 'top'
            }
        },
        {
            path: '/videoklipp/s%C3%B6k',
            name: 'sv.VideosSearch',
            component: () => import('@/views/VideosSearch'),
            meta: {
                scroll: 'top'
            }
        },
        {
            path: '/videot/:id/:urlName?',
            name: 'fi.VideoPage',
            component: () => import('@/views/VideoPage'),
            props: true,
            meta: {
                scroll: 'top'
            }
        },
        {
            path: '/videos/:id/:urlName?',
            name: 'en.VideoPage',
            component: () => import('@/views/VideoPage'),
            props: true,
            meta: {
                scroll: 'top'
            }
        },
        {
            path: '/videoklipp/:id/:urlName?',
            name: 'sv.VideoPage',
            component: () => import('@/views/VideoPage'),
            props: true,
            meta: {
                scroll: 'top'
            }
        },
        {
            path: '/videot',
            name: 'fi.Videos',
            component: () => import('@/views/VideosIndex')
        },
        {
            path: '/videos',
            name: 'en.Videos',
            component: () => import('@/views/VideosIndex')
        },
        {
            path: '/videoklipp',
            name: 'sv.Videos',
            component: () => import('@/views/VideosIndex')
        },

        /** Podcast audios */
        {
            path: '/podcastit/haku',
            name: 'fi.AudiosSearch',
            component: () => import('@/views/AudiosSearch'),
            meta: {
                scroll: 'top'
            }
        },
        {
            path: '/podcasts/search',
            name: 'en.AudiosSearch',
            component: () => import('@/views/AudiosSearch'),
            meta: {
                scroll: 'top'
            }
        },
        {
            path: '/podcaster/s%C3%B6k',
            name: 'sv.AudiosSearch',
            component: () => import('@/views/AudiosSearch'),
            meta: {
                scroll: 'top'
            }
        },
        {
            path: '/podcastit/:id/:urlName?',
            name: 'fi.AudioPage',
            component: () => import('@/views/AudioPage'),
            props: true,
            meta: {
                scroll: 'top'
            }
        },
        {
            path: '/podcasts/:id/:urlName?',
            name: 'en.AudioPage',
            component: () => import('@/views/AudioPage'),
            props: true,
            meta: {
                scroll: 'top'
            }
        },
        {
            path: '/podcaster/:id/:urlName?',
            name: 'sv.AudioPage',
            component: () => import('@/views/AudioPage'),
            props: true,
            meta: {
                scroll: 'top'
            }
        },
        {
            path: '/podcastit',
            name: 'fi.Audios',
            component: () => import('@/views/AudiosIndex')
        },
        {
            path: '/podcasts',
            name: 'en.Audios',
            component: () => import('@/views/AudiosIndex')
        },
        {
            path: '/podcaster',
            name: 'sv.Audios',
            component: () => import('@/views/AudiosIndex')
        },

        /** misc */
        {
            path: '/osuuskunta',
            name: 'fi.Cooperative',
            component: () => import('@/views/CooperativePage'),
            meta: {
                noSessionCheck: true,
                scroll: 'top'
            }
        },
        {
            path: '/cooperative',
            name: 'en.Cooperative',
            component: () => import('@/views/CooperativePage'),
            meta: {
                noSessionCheck: true,
                scroll: 'top'
            }
        },
        {
            path: '/kooperativ',
            name: 'sv.Cooperative',
            component: () => import('@/views/CooperativePage'),
            meta: {
                noSessionCheck: true,
                scroll: 'top'
            }
        },
        {
            path: '/terms',
            name: 'TermsOfService',
            component: () => import('@/views/TermsOfServicePage'),
            meta: {
                scroll: 'top'
            }
        },
        {
            path: '/privacy',
            name: 'PrivacyPolicy',
            component: () => import('@/views/PrivacyPolicyPage'),
            meta: {
                scroll: 'top'
            }
        },
        {
            path: '/loggedout',
            name: 'LoggedOut',
            component: () => import('@/views/LoggedOutPage'),
            meta: {
                loginReturnUrl: '/',
                scroll: 'top'
            }
        },
        {
            path: '/exit',
            name: 'Exit',
            component: () => import('@/views/ExitPage'),
            meta: {
                loginReturnUrl: '/',
                scroll: 'top'
            }
        },
        {
            path: '/verifyemail',
            name: 'VerifyEmail',
            component: () => import('@/views/VerifyEmail'),
            meta: {
                loginReturnUrl: '/',
                noSessionCheck: true,
                navbarClassName: 'dark fixed transparent no-items'
            }
        },
        {
            path: '/emailverified',
            name: 'EmailVerified',
            component: () => import('@/views/EmailVerified'),
            meta: {
                loginReturnUrl: '/user',
                noSessionCheck: true,
                navbarClassName: 'dark fixed transparent no-items'
            }
        },
        {
            path: '/passwordchanged',
            name: 'PasswordChanged',
            component: () => import('@/views/InfoMessagePage'),
            meta: {
                loginReturnUrl: '/user',
                noSessionCheck: true,
                navbarClassName: 'dark fixed transparent no-items'
            }
        },
        {
            path: '/pleaselogin',
            name: 'PleaseLogin',
            component: () => import('@/views/InfoMessagePage'),
            meta: {
                loginReturnUrl: '/user',
                noSessionCheck: true,
                navbarClassName: 'dark fixed transparent no-items no-login no-register no-logo'
            }
        },
        {
            path: '/accountunblocked',
            name: 'AccountUnblocked',
            component: () => import('@/views/InfoMessagePage'),
            meta: {
                loginReturnUrl: '/user',
                noSessionCheck: true,
                navbarClassName: 'dark fixed transparent no-items'
            }
        },
        {
            path: '/register/info',
            name: 'RegistrationInfo',
            component: () => import('@/views/RegisterInfoPage'),
            meta: {
                loginReturnUrl: '/',
                noSessionCheck: true
            }
        },
        {
            path: '/register/:secret?',
            name: 'Register',
            component: () => import('@/views/RegisterPage'),
            meta: {
                loginReturnUrl: '/',
                noSessionCheck: true,
                navbarClassName: 'dark fixed transparent no-items'
            }
        },
        {
            path: '/kiitos',
            name: 'fi.ThankYouForContacting',
            component: () => import('@/views/InfoMessagePage'),
            meta: {
                navbarClassName: 'dark fixed transparent'
            }
        },
        {
            path: '/thank-you',
            name: 'en.ThankYouForContacting',
            component: () => import('@/views/InfoMessagePage'),
            meta: {
                navbarClassName: 'dark fixed transparent'
            }
        },
        {
            path: '/tack',
            name: 'sv.ThankYouForContacting',
            component: () => import('@/views/InfoMessagePage'),
            meta: {
                navbarClassName: 'dark fixed transparent'
            }
        },
        {
            path: '/error',
            name: 'Error',
            component: () => import('@/views/ErrorPage'),
            meta: {
                loginReturnUrl: '/',
                scroll: 'top'
            }
        },

        /** Tribe playground for testing */
        {
            path: '/playground/tribe',
            name: 'TribePlayground',
            component: () => import('@/views/Tribe2Page'),
            props: true
        },
        /** Tribe community routes */
        {
            path: '/yhteiso',
            alias: '/yhteis%C3%B6',
            name: 'fi.Community',
            component: () => import('@/views/CommunityHome')
        },
        {
            path: '/community',
            name: 'en.Community',
            component: () => import('@/views/CommunityHome')
        },
        {
            path: '/gemenskap',
            name: 'sv.Community',
            component: () => import('@/views/CommunityHome')
        },
        // admin
        {
            path: '/admin',
            name: 'Admin',
            component: () => import('@/views/Tribe1Page'),
            meta: {
                scroll: 'top'
            }
        },
        // embed
        {path: '/embed/*', name: 'embed', component: () => import('@/views/Tribe1Page')},
        // topics
        {path: '/topics/:id?', name: 'topics', component: () => import('@/views/Tribe1Page')},
        // groups
        {path: '/groups/:id?', name: 'groups', component: () => import('@/views/Tribe1Page')},
        // user
        {path: '/user/:id?', name: 'user', component: () => import('@/views/Tribe1Page')},
        // settings
        {path: '/settings/:section?', name: 'settings', component: () => import('@/views/Tribe1Page')},
        // auth/<telegram tmv.>
        {path: '/auth/:authtype', name: 'auth', component: () => import('@/views/Tribe1Page')},
        // home/questions
        {path: '/home/questions/:id?', name: 'home-questions', component: () => import('@/views/Tribe1Page')},
        // home/discussions
        {path: '/home/discussions/:id?', name: 'home-discussions', component: () => import('@/views/Tribe1Page')},
        // home/posts
        {path: '/home/posts/:id?', name: 'home-posts', component: () => import('@/views/Tribe1Page')},
        // group/<id/slug>
        {path: '/group/:id', name: 'group', component: () => import('@/views/Tribe1Page')},
        // post/<id/slug>
        {path: '/post/:id', name: 'post', component: () => import('@/views/Tribe1Page')},
        // question/<id/slug>
        {path: '/question/:id', name: 'question', component: () => import('@/views/Tribe1Page')},

        // questions
        // discussions
        // shortposts
        // posts

        /** Default route */
        {
            path: '*',
            redirect: '/',
            meta: {
                loginReturnUrl: '/',
                scroll: 'top',
                navbarClassName: 'dark transparent absolute'
            }
        }
    ],

    scrollBehavior: function (to, from, savedPosition) {

        // console.log("scrollBehavior", to, savedPosition);

        // accept saved position
        if (savedPosition) {
            return savedPosition;
        }

        // accept query param scroll=keep
        if (to.query && to.query.scroll && to.query.scroll === 'keep') {
            return savedPosition;
        }
        // accept route meta scroll: keep
        if (to.meta && to.meta.scroll && to.meta.scroll === 'keep') {
            return savedPosition;
        }

        // scroll to top when navigating from Home
        if (from && from.name && from.name.match('Home')) {
            return { x: 0, y: 0 };
        }

        // if route changed because pagination component changed ?p param in query, keep position
        if (to.query && to.query.p) {
            return false;
        }

        let element;

        // scroll to submenu with OrganizatioPage visitor links
        if (to.params.section === 'visitor') {
            element = '.submenu.navbar';
        }
        // no scroll if navigating in subsections within same Id
        else if (to.params.section && (to.params.id === from.params.id)) {
            return false;
        }
        // scroll quirks
        else if (to.meta && typeof to.meta.scroll !== 'undefined') {
            const scroll = to.meta.scroll;
            if (scroll === false) {
                // if meta.scroll is explicitly set to false, no scroll
                return false;
            }
            else if (typeof scroll === 'string') {
                // scroll to 'auto' or a set element on the page?
                element = scroll;
                if (scroll === 'auto') {
                    if (from.name === to.name && !to.path.match('info')) {
                        // if navigating within one "EntityPage", scroll to submenu.navbar
                        // except info page, it scrolls to top
                        element = '.submenu.navbar';
                    }
                    else {
                        // scroll to main container
                        element = 'div.container';
                    }
                }
                else if (scroll === 'top') {
                    // scroll to top
                    return { x: 0, y: 0 };
                }
            }
            else if (typeof scroll === 'object') {
                return scroll;
            }
        }

        if (element) {
            // scroll to given container top offset (with a small margin)
            const el = document.querySelector(element);
            const y = (el && el.offsetTop - 10) || 0;
            return {x: 0, y: y};
        }
        else {
            // no scroll!
            return false;
        }
    }
});


export default router;
